import { render, staticRenderFns } from "./ImportiereHersteller.vue?vue&type=template&id=c7b56cee&"
import script from "./ImportiereHersteller.vue?vue&type=script&lang=js&"
export * from "./ImportiereHersteller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports